var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.313 16.047H9.35712V13.9528H29.313L25.7342 10.3737L27.2255 8.86534L33.36 14.9999L27.2255 21.1345L25.7342 19.6262L29.313 16.047ZM19.9305 10.3845V3.44034C19.9305 3.29061 19.8824 3.1677 19.7863 3.07158C19.6902 2.97547 19.5674 2.92742 19.418 2.92742H3.44046C3.29074 2.92742 3.16782 2.97547 3.07171 3.07158C2.9756 3.1677 2.92754 3.29061 2.92754 3.44034V26.5595C2.92754 26.7092 2.9756 26.8321 3.07171 26.9283C3.16782 27.0244 3.29074 27.0724 3.44046 27.0724H19.418C19.5674 27.0724 19.6902 27.0244 19.7863 26.9283C19.8824 26.8321 19.9305 26.7092 19.9305 26.5595V19.6153H22.0246V26.5595C22.0246 27.2737 21.7687 27.8867 21.2567 28.3987C20.7448 28.9106 20.1318 29.1666 19.418 29.1666H3.44046C2.72629 29.1666 2.11323 28.9106 1.60129 28.3987C1.08935 27.8867 0.833374 27.2737 0.833374 26.5595V3.44034C0.833374 2.72617 1.08935 2.11311 1.60129 1.60117C2.11323 1.08922 2.72629 0.833252 3.44046 0.833252H19.418C20.1318 0.833252 20.7448 1.08922 21.2567 1.60117C21.7687 2.11311 22.0246 2.72617 22.0246 3.44034V10.3845H19.9305Z",
    fill: "#F05A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.af18260bf931d2739be77594e9344084.svg";
export { ForwardRef as ReactComponent };